import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import { useIdParams } from '@feathr/extender/hooks';

import { DonationFormBuilderProvider } from './useDonationFormBuilder';

interface IProps {
  children: ReactNode;
}

function Root({ children }: Readonly<IProps>): JSX.Element {
  const donationForm = useIdParams('donationForm');

  return (
    <DonationFormBuilderProvider donationForm={donationForm}>
      {children}
    </DonationFormBuilderProvider>
  );
}

export default observer(Root);
